export class ExamPrice {
    constructor(id, name, input) {
        this.id = id;
        this.input = input;
        this.name = name;
        input.on("input", () => this.onChanged());
        this.oldPrice = this.price;
        this.centerPrice.forEach((centerPrice) => centerPrice.addEventListener("commission-changed", () => this.onCommissionChanged()));
    }
    get centerPrice() {
        return document.querySelectorAll(`.js-center-price-${this.id}`);
    }
    get inputValue() {
        const value = this.input.val();
        return value === "" ? "0" : value;
    }
    set price(price) {
        if (this.price !== price) {
            this.input.val(price === 0 ? "" : price);
            this.onChanged();
        }
    }
    get price() {
        const price = this.inputValue;
        if (price.match(/^[0-9]+(\.[0-9]+)?$/) === null) {
            throw new Error(incorrectPrice.replace("{exam}", this.name));
        }
        return parseFloat(price);
    }
    set empty(value) {
        this.input.val("");
        this.onChanged();
    }
    get empty() {
        return this.inputValue === "0";
    }
    synchronizeWithPartner() {
        if (this.partner === undefined || this.partner.price === this.price) {
            return;
        }
        this.partner.price = this.price;
        this.partner.onCommissionChanged();
    }
    focus() {
        this.input.focus();
    }
    onChanged() {
        if (this.changedCallback !== undefined) {
            this.changedCallback();
        }
        this.synchronizeWithPartner();
        this.changeCenterPrice();
    }
    get ajaxObject() {
        return { id: this.id, price: this.price };
    }
    init() {
        if (!this.empty) {
            this.onChanged();
        }
    }
    changeCenterPrice() {
        this.centerPrice.forEach((centerPriceElement) => {
            const commissionPercentage = parseFloat(centerPriceElement.dataset["commission"]);
            const commission = parseFloat((this.price * (commissionPercentage / 100)).toFixed(2));
            const centerPrice = this.price - commission;
            centerPriceElement.innerHTML = centerPrice.toString();
        });
    }
    onCommissionChanged() {
        this.changeCenterPrice();
        this.synchronizeWithPartner();
    }
}
